import { formatDateSchedule, formatDateStandard } from '@/services/dateFormatter';
import { Lieux } from '@/store/centreVaccination/types';
import { CodePostal } from '@/store/codePostal/types';
import { CodeScolaire } from '@/store/codeScolaire/types';
import { CategorieLieuType, LotType } from '@/store/folder/types';
import dayjs from 'dayjs';
import _ from 'lodash';
import { valeurVaccinParDefaut } from './adapter';

export const initCategorieLieu: CategorieLieuType = {
	categorieLieuId: -1,
	libelle: ''
};

export const initialCentreVaccination: Lieux = {
	code: '',
	codePostal: '',
	libelle: '',
	lieuId: -1,
	libelleCommune: '',
	categorieLieu: _.cloneDeep(initCategorieLieu),
	libelleAffichage: '',
	dateFermeture: ''
};

export const initialCodePostalLocalite: CodePostal = {
	codePostal: '',
	codePostalId: -1,
	libelle: '',
	libelleAffichage: ''
};

export const initialCodeScolaire: CodeScolaire = {
	etablissementId: -1,
	codeEtablissement: '',
	appellationOfficielle: '',
	codePostal: '',
	libelleCommune: '',
	libelleAffichage: ''
};

export const initialLot: LotType = {
	lotId: 0,
	numeroLot: '',
	autreLot: false,
	datePeremption: ''
};

export const initDetailsVaccin = () => ({
	vaccin: valeurVaccinParDefaut,
	lot: '',
	stadeVaccination: { stade: 1, libelle: '1ère vaccination' },
	dateInjection: formatDateStandard(dayjs()),
	horaireVaccination: formatDateSchedule(dayjs()),
	zoneVaccination: 'Bras gauche'
});

export const initDetailsLocalisation = () => ({
	lieuVaccination: _.cloneDeep(initCategorieLieu),
	centreVaccination: _.cloneDeep(initialCentreVaccination),
	codePostal: '',
	numFiness: '',
	codeScolaire: ''
});
